<ng-content select="[left]"></ng-content>
@if (
  icon() && (settings().iconPosition === 'left' || !settings().iconPosition)
) {
  <icon
    [iconDefinition]="icon()"
    [iconSize]="iconSize()!"
    [iconColor]="iconColor()"
  ></icon>
}
<span uichiplabel>{{ label() && !iconOnly() ? label() : '' }}</span>
@if (icon() && settings().iconPosition === 'right') {
  <icon
    [iconDefinition]="icon()"
    [iconSize]="iconSize()!"
    [iconColor]="iconColor()"
  ></icon>
}
<ng-content select="[right]"></ng-content>
